import { render, staticRenderFns } from "./PoiPicture.vue?vue&type=template&id=365feaf4"
import script from "./PoiPicture.js?vue&type=script&lang=js&external"
export * from "./PoiPicture.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports